// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_VERIFIED = "Ov\u011b\u0159en\u00e1 recenze";
